import ColorValue from "types/enums/ColorValue";
import HamburgerButton from "components/buttons/HamburgerButton";
import MenuMobile from "components/header/MenuMobile";
import ResponsiveContainer from "components/containers/ResponsiveContainer";
import styles from "css/header/HeaderMobile.module.css";
import { useState } from "react";
import HeaderTheme from "types/enums/HeaderTheme";

type Props = {
  headerTheme: HeaderTheme;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function HeaderMobile({ headerTheme }: Props): JSX.Element {
  const [isMenuShown, setIsMenuShown] = useState<boolean>(false);

  return (
    <>
      {isMenuShown && <MenuMobile onHide={() => setIsMenuShown(false)} />}
      <div className={styles.containerOuter}>
        <ResponsiveContainer className={styles.containerResponsive}>
          <div className={styles.containerInner}>
            <HamburgerButton colorValue={ColorValue.Primary} isShown={false} />
            <a href="/" style={{ textDecoration: "none" }}>
              <h3 className={styles.logo}>formf(n)</h3>
            </a>
            <HamburgerButton
              colorValue={ColorValue.Primary}
              onClick={() => setIsMenuShown(true)}
            />
          </div>
        </ResponsiveContainer>
      </div>
    </>
  );
}
